import { call, options, params } from './helpers';

export const getFeed = (payload) => call(`/beta/feed${params(payload)}`);
